import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { UserContext } from '@/app/UserProvider';
import { FormLayout } from '@/components/common/FormLayout';
import { PageLayout } from '@/components/common/PageLayout';
import { ForgotPasswordForm } from '@/components/forgot-password/ForgotPasswordForm';

export default function ForgotPasswordIndex() {
  const { user } = useContext(UserContext);
  const { t } = useTranslation();

  if (!user) {
    return (
      <PageLayout>
        <FormLayout title={t('auth.forgotPassword.title')}>
          <ForgotPasswordForm />
        </FormLayout>
      </PageLayout>
    );
  }
}